export default "__VITE_ASSET__BTaaP0Zn__"